import React from 'react';
import { Card } from 'primereact/card';

interface TestimonialCardProps {
  quote: string;
  author: string;
}

const TestimonialCard: React.FC<TestimonialCardProps> = ({ quote, author }) => {
  return (
    <div className="col-12 md:col-6 lg:col-4 px-3 mb-4">
      <Card className="h-100 surface-card shadow-2 border-round">
        <p className="text-lg mb-3 text-700"><span className="text-color-secondary text-xl mr-1">“</span>{quote}<span className="text-color-secondary text-xl ml-1">”</span></p>
        <p className="text-secondary">- {author}</p>
      </Card>
    </div>
  );
};

export default TestimonialCard;